import { useCallback, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getSelectedParcels } from '../selectors'

import { BASE_URL } from '../../constants'


const DetailsLabel = ({ mapId, details, index }) => {
  const [selectedIndex, setSelectedIndex] = index
  const [showDetails, setShowDetails] = useState(true)
  const [showList, setShowList] = useState(true)
  const [
    { parcel, elementarySchool, middleSchool, highSchool, evacuationZone, floodZone, stormwaterEasement, municipality },
    isLoading
  ] = details
  const selectedParcels = useSelector(getSelectedParcels)

  const gotoDetails = useCallback(() => {
    if (selectedParcels.length) {
      const PIN = parcel && parcel.PIN
      window.open(`${BASE_URL}details/${PIN}`, '_blank')
    }
  }, [selectedParcels, parcel])

  useEffect(() => {
    if (selectedParcels && selectedParcels.length === 1) setShowDetails(true)
    else if (selectedParcels) {
      setShowList(true)
      setShowDetails(false)
    }
  }, [selectedParcels])

  if (selectedParcels.length && parcel) {
    const detailsLabelId = `detailsLabel-${mapId}`
    let { OwnerName, PIN, LegalDescr, OwnerStreet, OwnerZip, OwnerState, OwnerCity, TaxDistrict } = parcel || {}
    OwnerName = OwnerName && OwnerName.toLowerCase()

    if (selectedParcels.length === 1) {
      return (
        <div className="details--complete no-accordion">
          <label className="wrapper--display ">
            <div className="map--search-result-display ">{`${OwnerName} (${PIN})`}</div>
          </label>
          <input id={detailsLabelId} type="checkbox" className="off-the-grid" checked={showDetails} onChange={()=>setShowDetails(x => !x)} />
          <label htmlFor={detailsLabelId} className="details-view"><img src={`${BASE_URL}images/details-icon.svg`} alt="details icon"/> </label>
          <div className="details">
            <dl className="details--important"> 
              <dt>Details View</dt>
              <dd>{OwnerName} ({PIN})</dd> 
              </dl>
            <div className="column">
              <dl className="details--important">
                <dt>Owner Info</dt>
                  <dd>{OwnerName}</dd>
                  <dd>{OwnerStreet}</dd>
                  <dd>{OwnerCity}, {OwnerState} {OwnerZip}</dd>
              </dl>
              <dl className="details--important">
                <dt>Property Info</dt>
                  <dd><span>Pin&thinsp;:</span><span>{PIN}</span></dd>
                  <dd><span>Legal&thinsp;: </span><span>{LegalDescr}</span></dd>
              </dl>
              <dl className="details--important">
                  <dt>School District</dt>
                      <dd className="column"><span>{isLoading.elementarySchool ? <span className="loading">LOADING...</span> : elementarySchool}</span></dd>
                      <dd className="column"><span>{isLoading.middleSchool ? <span className="loading">LOADING...</span> : middleSchool}</span></dd>
                      <dd className="column"><span>{isLoading.highSchool ? <span className="loading">LOADING...</span> : highSchool}</span></dd>
                  </dl>
              <div className="details--important"> <span>FEMA Flood Zone&thinsp;:</span><span>{isLoading.floodZone ? <span className="loading">LOADING...</span> : floodZone}</span></div>
              <div className="details--important"><span> Evacuation Zone&thinsp;:</span><span>{isLoading.evacuationZone ? <span className="loading">LOADING...</span> : evacuationZone}</span></div>
              <div className="details--important"><span> Stormwater Easement&thinsp;:</span><span>{isLoading.stormwaterEasement ? <span className="loading">LOADING...</span> : stormwaterEasement}</span></div>
              <div className="details--important"><span> Municipality&thinsp;:</span><span>{isLoading.municipality ? <span className="loading">LOADING...</span> : municipality}</span></div>
              <div className="details--important"><span> Tax District&thinsp;:</span><span>{TaxDistrict}</span></div>
            </div>
          <button className="details-go-to" onClick={gotoDetails}><img src={`${BASE_URL}images/print-icon.svg`} alt="print icon" />Print Preview</button>
          </div>
         </div>
      )
    } else {
      return (
        <div className="details--complete">
          <input id={detailsLabelId} type="checkbox" className="off-the-grid" checked={showList} onChange={() => setShowList(x => !x)} />
          <label htmlFor={detailsLabelId} className="wrapper--display">
            <div className="map--search-result-display ">{OwnerName} ({PIN})</div>
          </label>
          <div className="display--accordion">
            <ul>{selectedParcels.map((feature, i) => {
              const parcel = (feature && feature.attributes) || {}
              return (<li key={i} onClick={() => { setShowDetails(true); setSelectedIndex(i)}}>{parcel.OwnerName && parcel.OwnerName.toLowerCase()} ({parcel.PIN})</li>)
            })}</ul>
          </div>
          <div className="display--counter">{selectedIndex + 1} of {selectedParcels.length}</div>
          
          <input id={`${detailsLabelId}-details`} type="checkbox" className="off-the-grid" checked={showDetails} onChange={()=>setShowDetails(x => !x)} />
            <label htmlFor={`${detailsLabelId}-details`} className="details-view"><img src={`${BASE_URL}images/details-icon.svg`} alt="details icon"/> </label>
            <div className="details">
            <dl className="details--important"> 
              <dt>Details View</dt>
              <dd>{OwnerName} ({PIN})</dd> 
              </dl>
            <div>
              <dl className="details--important">
                <dt>Owner Info</dt>
                  <dd>{OwnerName}</dd>
                  <dd>{OwnerStreet}</dd>
                  <dd>{OwnerCity}, {OwnerState} {OwnerZip}</dd>
              </dl>
              <dl className="details--important">
                <dt>Property Info</dt>
                  <dd><span>Pin&thinsp;:</span><span>{PIN}</span></dd>
                  <dd><span>Legal&thinsp;: </span><span>{LegalDescr}</span></dd>
              </dl>
              <dl className="details--important">
                  <dt>School District</dt>
                      <dd className="column"><span>{isLoading.elementarySchool ? <span className="loading">LOADING...</span> : elementarySchool && elementarySchool.SCHOOL}</span></dd>
                      <dd className="column"><span>{isLoading.middleSchool ? <span className="loading">LOADING...</span> : middleSchool && middleSchool.SCHOOL}</span></dd>
                      <dd className="column"><span>{isLoading.highSchool ? <span className="loading">LOADING...</span> : highSchool && highSchool.SCHOOL}</span></dd>
                  </dl>
                  <div className="details--important"> <span>FEMA Flood Zone&thinsp;:</span><span>{isLoading.floodZone ? <span className="loading">LOADING...</span> : floodZone && floodZone.FLD_ZONE !== 'X' ? 'YES' : 'NO'}</span></div>
              <div className="details--important"><span> Evacuation Zone&thinsp;:</span><span>{isLoading.evacuationZone ? <span className="loading">LOADING...</span> : evacuationZone ? evacuationZone.Zone : 'NONE'}</span></div>
              <div className="details--important"><span> Stormwater Easement&thinsp;:</span><span>{isLoading.stormwaterEasement ? <span className="loading">LOADING...</span> : stormwaterEasement}</span></div>
              <div className="details--important"><span> Municipality&thinsp;:</span><span>{isLoading.municipality ? <span className="loading">LOADING...</span> : municipality}</span></div>
              <div className="details--important"><span> Tax District&thinsp;:</span><span>{TaxDistrict}</span></div>
            </div>
      
          <button className="details-go-to" onClick={gotoDetails}><img src={`${BASE_URL}images/print-icon.svg`} alt="print icon" />Print Preview</button>
          </div>
        </div>
      )
    }
  } else {
    if (selectedIndex !== 0) {
      setSelectedIndex(0)
    }
    // returning empty div.  null is causing an error
    return <div></div>
  }
}

export default DetailsLabel